module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATRJREFUeNrsVDtuwkAQdZD7mILavkG4QcwJYiT6pKfhBvERaKiz9BRwgpgbmBs4dRrnBplBz+gx8mfbRH7SaljPzHszu7MEwYgR/w0PvoGz9eFZzFxWJKv43q3OA/GPYlLkKLaS89P4Qw/BdzEbCPL3iInoeywml/VmXFrAclBYCJ7EOKrY51RetTNbZBvCHtGihyC33ULU9WjlvJl4ih7pd42u+kQ1pqS9k0IvnR13iOpdVbIy7MumWwyQI1+A2Lkp9tg51ULyApI7URHZY6IL6qaJy0x8iZyL5HzQgFV0ItcXEdLk5qaoqygR1hCJMOUWWlhGd+9IOCF+5ZlOWi5eHSmJBiBL4bOoUOSCBw7vfNsSX9+OWjr+BPHtqDz/FPS+TwNPLEZOQoP2ZQNGjPj7+BVgAG/YfDUW1rFHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/mar/57.png
// module id = 777
// module chunks = 0